<template>
  <a-layout class='index animated fadeIn s_bf'>
      <a-form ref="form" :model="search" :style="{ 'marginBottom': '25px' }" :initialValues="search" :onFinish="pageSearchChange" layout="inline">
        <a-form-item label name="keywords">
          <a-input-group compact :style="{ width: '360px' }">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value>全部</a-select-option>
              <a-select-option value="author">发放者</a-select-option>
              <a-select-option value="description">红包说明</a-select-option>
              <a-select-option value="use_description">使用说明</a-select-option>
              <a-select-option value="amount">红包余额</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="创建日期" name="time">
          <a-range-picker v-model:value="time" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" @change="onChange" />
        </a-form-item>
        <a-form-item label="红包类型" name="bonus_type">
          <a-select v-model:value="search.bonus_type" :style="{ width: '140px' }" placeholder="全部">
            <a-select-option value>全部</a-select-option>
            <a-select-option :value="1">微信红包</a-select-option>
            <a-select-option :value="2">企业付款</a-select-option>
            <!-- <a-select-option :value="3">代发红包</a-select-option> -->
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit" class="m-r-10">搜索</a-button>
          <a-button type="primary" htmlType="submit" class="m-r-10">刷新</a-button>
          <a href="/assets/red/create?type=add" target="_blank">新建红包</a>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='data'  >
        <template v-slot:status="{ record }">
          <p>{{record.status?'正常':'禁用'}}</p>
        </template>
        <template v-slot:action="{ record }">
           <a-button type="primary" @click='select(record)' v-if='!checkout'>选择</a-button>
          <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  </a-layout>

</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
getBonusList
} from "@/api/red";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 8,
  status: "",
  key_type: "",
  start_time: "",
  end_time: "",
  keyword: "",
  bonus_status:"1",
  bonus_type: "",
};

export default {
  name:'selectBouns',
  props:{
    scene_type:{
      type:Number,
      defalut(){
        return null
      }
    }
  },
  setup(props, {emit}) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      list: [
      ],
      listLoading: false,
      time: [],
      total: 1,
      level: null,
    });
    let columns = [
      {
        title: "红包ID",
        dataIndex: "id",
        key: "id"
      },
      {
        title: "红包类型",
        dataIndex: "bonus_type_text",
        key: "bonus_type_text"
      },
      {
        title: "红包金额",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "发放者",
        dataIndex: "author",
        key: "author",
      },
      {
        title: "红包说明",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "使用说明",
        dataIndex: "use_description",
        key: "use_description",
      }, {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "状态",
        key: "status",
        customRender:({record})=>{
            return  record.is_money_valid == 1 ? '启用' : '禁用'
        } 
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      try { 
        let res = await getBonusList({
          ...values,
          scene_type:props.scene_type || ''
        }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
         //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        if(e!=0){
        e.select = !e.select
        }
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        e.select = !e.select
      }
      //多选确认
      const confirm = () =>{  
        state.selectList = []
        for(var i in data.value){
          if(data.value[i].select == true){
            state.selectList.push(data.value[i])
          }
        }
        emit("select",state.selectList);
      }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      confirm,
      checkBnt,
      select
    };
  },
};
</script>